<template>
    <div class="main-content">
        <!-- TOASTS DE NOTIFICAÇÃO -->
        <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1060">
            <transition-group name="slide-fade">
                <div v-for="alert in alerts" :key="alert.id"
                    class="toast show align-items-center border-0 shadow-lg mb-2"
                    :class="'bg-' + alert.type + '-subtle text-' + alert.type" role="alert">
                    <div class="d-flex p-3">
                        <i :class="alert.icon" class="me-3 fs-5"></i>
                        <div class="toast-body p-0 fw-medium">
                            {{ alert.message }}
                        </div>
                        <button type="button" class="btn-close ms-auto" @click="removeAlert(alert.id)"></button>
                    </div>
                </div>
            </transition-group>
        </div>

        <header class="content-header mb-2 mt-n5">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb mb-0 flex-nowrap text-nowrap align-items-center">
                    <li class="breadcrumb-item">
                        <router-link class="nav-link d-inline" to="/">Início</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link class="nav-link d-inline" to="/list-page-lead">Páginas de Captura</router-link>
                    </li>
                    <li class="breadcrumb-item active text-dark small" aria-current="page">
                        {{ isEditing ? 'Editar Página' : 'Nova Página' }}
                    </li>
                </ol>
            </nav>
        </header>

        <div class="card p-4 shadow-subtle rounded-4 border-0">
            <div class="d-flex justify-content-between align-items-center mb-4 pb-2 border-bottom">
                <div>
                    <h4 class="mb-0 fw-bold">Configuração da Página</h4>
                    <span class="text-muted fs-7">Crie ou edite sua página de captura e visualize em tempo real</span>
                </div>

                <div class="d-flex gap-2">
                    <button class="btn btn-pmg-primary rounded-pill px-3 shadow-sm d-flex align-items-center"
                        @click="openAiModal" style="background: #0f172a;">
                        <i class="bi bi-magic me-2 text-warning"></i> Gerar com IA
                    </button>
                    <button class="btn btn-pmg-light rounded-pill px-3 shadow-sm d-flex align-items-center"
                        @click="startTour">
                        <i class="bi bi-info-circle me-2 text-primary"></i> Como criar?
                    </button>
                    <button class="btn btn-pmg-primary" @click="savePage" :disabled="loading">
                        <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"></span>
                        <i v-else class="bi bi-floppy me-1"></i>
                        {{ loading ? 'Salvando...' : (isEditing ? 'Atualizar Página' : 'Salvar Página') }}
                    </button>
                </div>
            </div>

            <div class="row g-4">
                <!-- COLUNA ESQUERDA: FORMULÁRIO -->
                <div class="col-lg-7">

                    <!-- BLOCO 1: TEXTOS (ID do Tour aplicado aqui) -->
                    <div id="tour-textos" class="card bg-light border-0 rounded-4 p-3 mb-4">
                        <h6 class="fw-bold mb-3 text-secondary">Layout e Textos</h6>
                        <div class="row g-3">
                            <div class="col-md-6">
                                <div class="d-flex justify-content-between align-items-center mb-1">
                                    <label class="form-label small fw-bold text-muted m-0">Banner (Imagem)</label>
                                    <select v-model="form.banner_size"
                                        class="form-select form-control-pmg form-select-sm w-auto bg-white text-secondary fw-medium"
                                        style="font-size: 0.75rem; padding: 2px 24px 2px 8px;">
                                        <option value="standard">Padrão (3:1 - Fino)</option>
                                        <option value="2x">2x Maior (2:1 - Altura Média)</option>
                                        <option value="3x">3x Maior (1:1 - Quadrado)</option>
                                    </select>
                                </div>
                                <ImageCropper :key="cropperKey" :aspect-ratio="bannerAspectRatio" :is-round="false"
                                    @cropped="blob => handleCropped(blob, 'banner')" />
                            </div>
                            <div class="col-md-6">
    <div class="d-flex justify-content-between align-items-center mb-1">
        <label class="form-label small fw-bold text-muted m-0">Logomarca (Imagem)</label>
        <!-- Seletor de Tamanho/Proporção da Logo -->
        <select v-model="form.logo_size" class="form-select form-control-pmg form-select-sm w-auto bg-white text-secondary fw-medium" style="font-size: 0.75rem; padding: 2px 24px 2px 8px;">
            <option value="standard">Quadrada (1:1)</option>
            <option value="rectangle">Retangular (2:1)</option>
            <option value="wide">Larga (3:1)</option>
        </select>
    </div>
    <!-- is-round agora é dinâmico, só fica redondo se for quadrada -->
    <ImageCropper :key="cropperKey" :aspect-ratio="logoAspectRatio" :is-round="isLogoRound"
        @cropped="blob => handleCropped(blob, 'logo')" />
</div>
                            <div class="col-md-12">
                                <label class="form-label small fw-bold text-muted">Título da Página</label>
                                <input v-model="form.title" type="text" class="form-control form-control-pmg"
                                    placeholder="Ex: Faça parte da nossa rede!">
                            </div>
                            <div class="col-md-12">
                                <label class="form-label small fw-bold text-muted">Subtítulo</label>
                                <input v-model="form.subtitle" type="text" class="form-control form-control-pmg"
                                    placeholder="Ex: Ao se cadastrar você será direcionado ao Whats...">
                            </div>
                        </div>
                    </div>

                    <!-- BLOCO 2: DESIGN E CORES (ID do Tour aplicado aqui) -->
                    <div id="tour-design" class="card bg-light border-0 rounded-4 p-3 mb-4">
                        <h6 class="fw-bold mb-3 text-secondary">Identidade Visual</h6>
                        <div class="row g-3">
                            <div class="col-md-6">
                                <label class="form-label small fw-bold text-muted">Cor Gradiente 1</label>
                                <input v-model="form.gradient_start_color" type="color"
                                    class="form-control form-control-color w-100 p-1 rounded-3">
                            </div>
                            <div class="col-md-6">
                                <label class="form-label small fw-bold text-muted">Cor Gradiente 2</label>
                                <input v-model="form.gradient_end_color" type="color"
                                    class="form-control form-control-color w-100 p-1 rounded-3">
                            </div>
                            <div class="col-md-6">
                                <label class="form-label small fw-bold text-muted">Texto do Botão (CTA)</label>
                                <input v-model="form.button_text" type="text" class="form-control form-control-pmg"
                                    placeholder="Ex: QUERO ME CADASTRAR">
                            </div>
                            <div class="col-md-6">
                                <label class="form-label small fw-bold text-muted">Cor do Botão</label>
                                <input v-model="form.button_color" type="color"
                                    class="form-control form-control-color w-100 p-1 rounded-3">
                            </div>
                        </div>
                    </div>

                    <!-- BLOCO 3: CAMPOS DINÂMICOS (ID do Tour aplicado aqui) -->
                    <div id="tour-campos" class="card bg-light border-0 rounded-4 p-3 mb-4">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <h6 class="fw-bold m-0 text-secondary">Campos Dinâmicos (Formulário)</h6>
                            <button class="btn btn-sm btn-pmg-light" @click="addField">
                                <i class="bi bi-plus-circle me-1"></i> Adicionar Campo
                            </button>
                        </div>

                        <div v-for="(field, index) in form.fields" :key="index"
                            class="p-3 border rounded-3 bg-white mb-2 position-relative">
                            <!-- Grupo de Botões (Estrela + Lixeira) no Canto Superior Direito -->
                            <div class="position-absolute top-0 end-0 m-2 d-flex align-items-center gap-1">
                                <!-- Botão Definir Identificador (Estrela) -->
                                <button type="button" class="btn btn-sm border-0 p-1"
                                    :class="field.is_identifier ? 'text-warning' : 'text-muted opacity-50'"
                                    @click="setIdentifier(index)"
                                    :title="field.is_identifier ? 'Campo identificador principal' : 'Definir como identificador'">
                                    <i class="bi"
                                        :class="field.is_identifier ? 'bi-star-fill fs-5' : 'bi-star fs-5'"></i>
                                </button>

                                <!-- Botão Excluir Campo (Lixeira) -->
                                <button type="button" class="btn btn-sm text-danger border-0 p-1"
                                    @click="removeField(index)" title="Excluir campo">
                                    <i class="bi bi-trash fs-5"></i>
                                </button>
                            </div>

                            <div class="row g-2 align-items-end">
                                <div class="col-md-5">
                                    <label class="form-label small fw-bold text-muted mb-1">Rótulo (Label)</label>
                                    <input v-model="field.label" type="text"
                                        class="form-control form-control-pmg form-control-sm"
                                        placeholder="Ex: Nome Completo">
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label small fw-bold text-muted mb-1">Tipo</label>
                                    <select v-model="field.type" class="form-select form-control-pmg form-select-sm">
                                        <option value="text">Texto Curto</option>
                                        <option value="email">E-mail</option>
                                        <option value="phone">Telefone/WhatsApp</option>
                                        <option value="select">Lista (Select)</option>
                                    </select>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-check mt-2">
                                        <input class="form-check-input" type="checkbox" v-model="field.is_required"
                                            :id="'req_' + index">
                                        <label class="form-check-label small" :for="'req_' + index">Obrigatório</label>
                                    </div>
                                </div>
                                <div class="col-md-12 mt-2" v-if="field.type === 'select'">
                                    <input v-model="field.options_text" type="text"
                                        class="form-control form-control-pmg form-control-sm"
                                        placeholder="Opções separadas por vírgula. Ex: Sim,Não,Talvez">
                                </div>
                            </div>
                        </div>
                        <div v-if="form.fields.length === 0" class="text-center text-muted small py-3">
                            Nenhum campo adicionado. Clique no botão acima para criar o formulário.
                        </div>
                    </div>

                    <!-- BLOCO 4: INTEGRAÇÃO -->
                    <div class="card bg-light border-0 rounded-4 p-3" id="tour-integracao">
                        <h6 class="fw-bold mb-3 text-secondary">Integração e Retorno</h6>
                        <div class="row g-3">
                            <div class="col-md-12">
                                <label class="form-label small fw-bold text-muted">URL de Destino
                                    (WhatsApp/Grupo)</label>
                                <input v-model="form.destination_url" type="url" class="form-control form-control-pmg"
                                    placeholder="https://wa.me/55...">
                            </div>
                            <div class="col-md-12">
                                <label class="form-label small fw-bold text-muted">Texto da Página de Obrigado</label>
                                <textarea v-model="form.thank_you_text" class="form-control form-control-pmg" rows="2"
                                    placeholder="Seus dados foram enviados com sucesso!"></textarea>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- COLUNA DIREITA: LIVE PREVIEW (ID do Tour aplicado aqui) -->
                <div id="tour-preview" class="col-lg-5">
                    <div class="preview-container shadow-lg rounded-4 p-4 sticky-top" :style="previewStyle">
                        <div class="preview-content bg-white rounded-4 shadow-sm overflow-hidden text-center pb-4">
                            <!-- Banner Preview -->
                            <div class="preview-banner bg-light d-flex align-items-center justify-content-center mb-4"
                                :style="previewBannerStyle">
                                <img v-if="previews.banner" :src="previews.banner" class="w-100 h-100 object-fit-cover">
                                <span v-else class="text-muted small">Área do Banner</span>
                            </div>

                            <!-- Logo Preview com tamanho aumentado -->
                            <!-- Logo Preview com tamanho e formato dinâmicos -->
<div class="preview-logo-wrapper mt-n4">
    <div class="preview-logo bg-white shadow-sm d-flex align-items-center justify-content-center mx-auto border"
         :style="previewLogoStyle"
         :class="{'rounded-circle': isLogoRound, 'rounded-3': !isLogoRound}">
        <img v-if="previews.logo" :src="previews.logo"
             class="w-100 h-100 object-fit-cover p-1" 
             :class="{'rounded-circle': isLogoRound, 'rounded-3': !isLogoRound}">
        <i v-else class="bi bi-image text-muted fs-2"></i>
    </div>
</div>

                            <!-- Textos Preview -->
                            <div class="px-4 mt-3">
                                <h4 class="fw-bold text-dark">{{ form.title || 'Título da sua Página' }}</h4>
                                <p class="text-muted small">{{ form.subtitle || 'Subtítulo atrativo ficará aqui.' }}</p>
                            </div>

                            <!-- Formulário Dinâmico Preview -->
                            <div class="px-4 mt-4 text-start">
                                <div v-for="(field, idx) in form.fields" :key="'prev_' + idx" class="mb-3">
                                    <label class="form-label small fw-bold text-secondary">{{ field.label || 'Novo Campo' }} <span v-if="field.is_required" class="text-danger">*</span></label>
                                    <select v-if="field.type === 'select'"
                                        class="form-select form-select-sm bg-light text-muted">
                                        <option>Selecione...</option>
                                        <option v-for="(opt, oIdx) in getOptionsList(field.options_text)" :key="oIdx">{{
                                            opt }}</option>
                                    </select>
                                    <input v-else :type="field.type === 'email' ? 'email' : 'text'"
                                        class="form-control form-control-sm bg-light"
                                        :placeholder="'Digite ' + (field.label || '').toLowerCase()">
                                </div>

                                <!-- Botão no Live Preview -->
                                <button class="btn w-100 mt-2 fw-bold text-white shadow-sm" :style="{
                                    backgroundColor: form.button_color || '#561569',
                                    opacity: form.fields.length === 0 ? 0.5 : 1,
                                    cursor: form.fields.length === 0 ? 'not-allowed' : 'pointer'
                                }" :disabled="form.fields.length === 0"
                                    title="Adicione pelo menos um campo para habilitar o botão">
                                    <i v-if="form.fields.length === 0" class="bi bi-lock-fill me-2"></i>
                                    {{ form.button_text || 'ENVIAR DADOS' }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ESTRUTURA DO TOUR NATIVO -->
        <transition name="fade">
            <div v-if="tourActive" class="tour-overlay" @click="finishTour"></div>
        </transition>

        <transition name="popover-anim">
            <div v-if="tourActive" class="tour-popover shadow-lg" :style="popoverStyle">
                <div class="d-flex justify-content-between align-items-start mb-2">
                    <h6 class="fw-bold mb-0" style="color: #561569;">{{ tourSteps[currentStep].title }}</h6>
                    <button class="btn-close btn-close-sm" @click="finishTour"></button>
                </div>

                <p class="small text-muted mb-3">{{ tourSteps[currentStep].description }}</p>

                <div class="d-flex justify-content-between align-items-center mt-auto pt-3 border-top border-light">
                    <span class="badge bg-light text-secondary border">
                        Passo {{ currentStep + 1 }} de {{ tourSteps.length }}
                    </span>
                    <div class="gap-2 d-flex">
                        <button v-if="currentStep > 0" class="btn btn-sm btn-pmg-light d-flex align-items-center"
                            @click="passoAnterior">
                            <i class="bi bi-chevron-left me-1 small"></i> Anterior
                        </button>
                        <button v-if="currentStep < tourSteps.length - 1"
                            class="btn btn-sm btn-pmg-primary text-white d-flex align-items-center"
                            @click="proximoPasso">
                            Próximo <i class="bi bi-chevron-right ms-1 small"></i>
                        </button>
                        <button v-else class="btn btn-sm btn-success text-white d-flex align-items-center"
                            @click="finishTour">
                            <i class="bi bi-check2-circle me-1 small"></i> Concluir
                        </button>
                    </div>
                </div>
            </div>
        </transition>
    </div>
    <!-- MODAL DE INTELIGÊNCIA ARTIFICIAL -->
    <transition name="fade">
        <div v-if="showAiModal" class="ai-modal-overlay" @click.self="closeAiModal">
            <div class="ai-modal-content shadow-lg rounded-4 bg-white p-4">
                <div class="d-flex justify-content-between align-items-center mb-3">
                    <h5 class="fw-bold mb-0 d-flex align-items-center" style="color: #561569;">
                        <i class="bi bi-magic fs-4 me-2 text-warning"></i> Assistente IA
                    </h5>
                    <button class="btn-close" @click="closeAiModal" :disabled="aiLoading"></button>
                </div>

                <p class="text-muted small mb-4">
                    Descreva o objetivo da sua página e nosso assistente criará os textos, cores e campos ideais para
                    converter seus leads.
                </p>

                <div class="mb-4">
                    <label class="form-label small fw-bold text-muted">Qual o seu objetivo com esta página?</label>
                    <textarea v-model="aiObjective" class="form-control form-control-pmg" rows="4"
                        placeholder="Ex: Quero capturar leads de empresários locais interessados em uma consultoria financeira gratuita."
                        :disabled="aiLoading"></textarea>
                </div>

                <div class="d-flex justify-content-end gap-2">
                    <button class="btn btn-pmg-light" @click="closeAiModal" :disabled="aiLoading">Cancelar</button>
                    <button class="btn btn-pmg-primary d-flex align-items-center" @click="generateWithAi"
                        :disabled="aiLoading || aiObjective.length < 5">
                        <span v-if="aiLoading" class="spinner-border spinner-border-sm me-2" role="status"></span>
                        {{ aiLoading ? 'Processando (pode levar alguns segundos)...' : 'Gerar Estratégia' }}
                    </button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import api from '@/services/api';
import ImageCropper from '@/components/ImageCropper.vue'

export default {
    components: { ImageCropper },
    data() {
        return {

            loading: false,
            alerts: [],
            pageId: null,
            form: {
                title: '',
                subtitle: '',
                gradient_start_color: '#f8fafc',
                gradient_end_color: '#e2e8f0',
                destination_url: '',
                thank_you_text: 'Seus dados foram enviados com sucesso!',
                fields: [],
                logo_file: null,
                banner_file: null,
                button_text: 'ENVIAR DADOS',
                button_color: '#561569',
                banner_size: 'standard',
                logo_size: 'standard'
            },
            previews: {
                logo: null,
                banner: null
            },
            showAiModal: false,
            aiObjective: '',
            aiLoading: false,
            // Configurações do Tour
            tourActive: false,
            currentStep: 0,
            popoverStyle: { top: '0px', left: '0px' },
            cropperKey: 0,
            tourSteps: [
                {
                    id: 'tour-textos',
                    title: 'Textos Principais',
                    description: 'Comece definindo o título, o subtítulo e carregando as imagens da sua página.'
                },
                {
                    id: 'tour-design',
                    title: 'Identidade Visual',
                    description: 'Escolha as cores de fundo e do botão para manter a página alinhada à sua marca.'
                },
                {
                    id: 'tour-campos',
                    title: 'Campos Dinâmicos',
                    description: 'Adicione os campos que o lead precisará preencher (Ex: Nome, E-mail, Telefone).'
                },
                {
                    id: 'tour-integracao',
                    title: 'Integração e Retorno',
                    description: 'Defina o link do WhatsApp (ou grupo) para onde o lead será enviado após o cadastro, além da mensagem de agradecimento.'
                },
                {
                    id: 'tour-preview',
                    title: 'Visualização em Tempo Real',
                    description: 'Conforme você ajusta as configurações, acompanhe aqui exatamente como a página ficará no celular do seu lead!'
                }
            ]
        }
    },
    computed: {
        isEditing() {
            return !!this.pageId;
        },
        bannerAspectRatio() {
            if (this.form.banner_size === '3x') return 1 / 1; // Quadrado (1:1)
            if (this.form.banner_size === '2x') return 2 / 1; // Retangular intermediário (2:1)
            return 3 / 1; // Padrão (3:1)
        },
        previewBannerStyle() {
            let height = '150px';
            if (this.form.banner_size === '2x') height = '220px';
            if (this.form.banner_size === '3x') height = '280px';

            return {
                height: height,
                width: '100%',
                transition: 'height 0.3s ease'
            };
        },

        logoAspectRatio() {
        if (this.form.logo_size === 'wide') return 3 / 1;
        if (this.form.logo_size === 'rectangle') return 2 / 1;
        return 1 / 1; // standard
    },
    isLogoRound() {
        return this.form.logo_size === 'standard'; // Só aplica a máscara redonda se for 1:1
    },
    previewLogoStyle() {
        // Ajusta a largura e a altura visual da logo para não quebrar o layout
        if (this.form.logo_size === 'wide') {
            return { width: '200px', height: '70px', transition: 'all 0.3s ease' };
        }
        if (this.form.logo_size === 'rectangle') {
            return { width: '160px', height: '80px', transition: 'all 0.3s ease' };
        }
        // Padrão (Redonda/Quadrada)
        return { width: '110px', height: '110px', transition: 'all 0.3s ease' };
    }


    },
    created() {
        // Verifica se veio um ID na rota (ex: /edit-page-lead/5)
        if (this.$route.params.id) {
            this.pageId = this.$route.params.id;
            this.fetchPageData(this.pageId);
        }
    },
    methods: {
        // Gerenciamento de alertas mantido
        showAlert(message, type = 'success') {
            const id = Date.now();
            let icon = 'bi-check-circle-fill';
            if (type === 'danger') icon = 'bi-exclamation-circle-fill';
            if (type === 'error') icon = 'bi-x-circle-fill';

            this.alerts.push({ id, message, type, icon });
            setTimeout(() => this.removeAlert(id), type === 'error' ? 6000 : 4000);
        },
        removeAlert(id) {
            this.alerts = this.alerts.filter(a => a.id !== id);
        },

        // Manipula uploads e cria preview em tempo de execução
        onFileChange(event, type) {
            const file = event.target.files[0];
            if (file) {
                if (type === 'logo') {
                    this.form.logo_file = file;
                    this.previews.logo = URL.createObjectURL(file);
                } else {
                    this.form.banner_file = file;
                    this.previews.banner = URL.createObjectURL(file);
                }
            }
        },

        // Campos Dinâmicos
        addField() {
            this.form.fields.push({
                id: null,
                name: '', // Será gerado no backend via slug do label
                label: '',
                type: 'text',
                is_required: false,
                is_identifier: this.form.fields.length === 0,
                options_text: '' // String temporária para quebrar no backend/frontend
            });
        },
        removeField(index) {
            this.form.fields.splice(index, 1);
        },
        getOptionsList(text) {
            if (!text) return [];
            return text.split(',').map(s => s.trim()).filter(s => s !== '');
        },

        // Salvar via API
        async savePage() {
            this.loading = true;
            try {
                const formData = new FormData();
                formData.append('title', this.form.title);
                formData.append('subtitle', this.form.subtitle);
                formData.append('gradient_start_color', this.form.gradient_start_color);
                formData.append('gradient_end_color', this.form.gradient_end_color);
                formData.append('destination_url', this.form.destination_url);
                formData.append('thank_you_text', this.form.thank_you_text);
                formData.append('button_text', this.form.button_text);
                formData.append('button_color', this.form.button_color);
                formData.append('banner_size', this.form.banner_size);
                formData.append('logo_size', this.form.logo_size);

                const slug = this.form.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)+/g, '');
                formData.append('slug', slug || 'pagina-' + Date.now());

                if (this.form.logo_file) formData.append('logo', this.form.logo_file, 'logo.jpg');
                if (this.form.banner_file) {
                    formData.append('banner', this.form.banner_file, 'banner.jpg')
                } else if (this.form.ai_banner_url) {
                    formData.append('banner', this.form.ai_banner_url);
                }

                this.form.fields.forEach((field, index) => {
                    // Se tem ID, envia obrigatoriamente
                    if (field.id) {
                        formData.append(`fields[${index}][id]`, field.id);
                    }

                    formData.append(`fields[${index}][label]`, field.label);

                    // Garante que o name nunca seja enviado em branco
                    const fieldName = field.name || field.label.toLowerCase().replace(/[^a-z0-9]+/g, '_');
                    formData.append(`fields[${index}][name]`, fieldName);

                    formData.append(`fields[${index}][type]`, field.type);
                    formData.append(`fields[${index}][is_required]`, field.is_required ? 1 : 0);
                    formData.append(`fields[${index}][is_identifier]`, field.is_identifier ? 1 : 0);

                    if (field.type === 'select') {
                        const opts = this.getOptionsList(field.options_text);
                        opts.forEach((opt, oIdx) => {
                            formData.append(`fields[${index}][options][${oIdx}]`, opt);
                        });
                    }
                });

                // Se for edição, o Laravel às vezes exige _method = PUT para FormData via POST
                if (this.isEditing) {
                    formData.append('_method', 'PUT');
                    await api.post(`/capture-pages/${this.pageId}`, formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    });
                    this.showAlert('Página atualizada com sucesso!');
                } else {
                    await api.post('/capture-pages', formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    });
                    this.showAlert('Página de captura criada com sucesso!');
                    this.resetForm();
                }

            } catch (e) {
               if (e.response?.status === 403) {
                    this.showAlert("Permissão de acesso ao recurso não autorizada.", "error");
                }else if (e.response?.status === 422) {
                    const validationErrors = e.response.data?.data || e.response.data?.errors;
                    this.errors = validationErrors || {};
                    if (!validationErrors || Object.keys(validationErrors).length === 0) {
                        this.showAlert("Erro de validação. Verifique os campos preenchidos.", "error");
                        return;
                    }
                    let mensagensErro = "Os seguintes campos precisam de correção:\n\n";
                    for (const campo in validationErrors) {
                        mensagensErro += `- ${validationErrors[campo][0]}\n`;
                    }

                    this.showAlert(mensagensErro, "error");

                } else {
                    console.error("Erro desconhecido:", e);
                    this.showAlert("Erro ao salvar página.", "error");
                }
            } finally {
                this.loading = false;
            }
        },

        // --- MÉTODOS DO TOUR ---
        startTour() {
            this.tourActive = true;
            this.currentStep = 0;
            this.focusElementActual();
        },

        finishTour() {
            this.tourActive = false;
            this.removerFocoAtual();
        },

        proximoPasso() {
            if (this.currentStep < this.tourSteps.length - 1) {
                this.removerFocoAtual();
                this.currentStep++;
                this.focusElementActual();
            }
        },

        passoAnterior() {
            if (this.currentStep > 0) {
                this.removerFocoAtual();
                this.currentStep--;
                this.focusElementActual();
            }
        },

        removerFocoAtual() {
            const step = this.tourSteps[this.currentStep];
            const el = document.getElementById(step.id);
            if (el) {
                el.classList.remove('tour-highlight');
            }
        },

        focusElementActual() {
            this.$nextTick(() => {
                const step = this.tourSteps[this.currentStep];
                const el = document.getElementById(step.id);

                if (el) {
                    // Adiciona o destaque e centraliza o elemento na tela
                    el.classList.add('tour-highlight');
                    el.scrollIntoView({ behavior: 'smooth', block: 'center' });

                    setTimeout(() => {
                        const rect = el.getBoundingClientRect();

                        // Dimensões estimadas do balão (width: 380px do CSS + uma margem de segurança)
                        const popoverWidth = 400;
                        const popoverHeight = 220;

                        // Posição Padrão: Logo abaixo do elemento destacado e alinhado à esquerda
                        let popoverTop = rect.bottom + 15;
                        let popoverLeft = rect.left;

                        // CORREÇÃO 1: Eixo Y (Vertical) - Evita sumir atrás do Menu do SO
                        // Se a posição Top calculada + a altura do balão for maior que a tela, 
                        // significa que vai vazar por baixo. Então jogamos o balão PARA CIMA do elemento.
                        if ((popoverTop + popoverHeight) > window.innerHeight) {
                            popoverTop = rect.top - popoverHeight - 15;
                        }

                        // Proteção extra: se ao jogar para cima, ele vazar pelo topo do navegador,
                        // fixamos ele um pouco abaixo do topo da tela.
                        if (popoverTop < 10) {
                            popoverTop = 20;
                        }

                        // CORREÇÃO 2: Eixo X (Horizontal) - Evita sumir na lateral (Bug do Live Preview)
                        // Se a posição Esquerda calculada + a largura do balão for maior que a tela,
                        // significa que vai vazar pela direita. Então encostamos na borda direita.
                        if ((popoverLeft + popoverWidth) > window.innerWidth) {
                            popoverLeft = window.innerWidth - popoverWidth;
                        }

                        // Proteção extra: se vazar pela esquerda
                        if (popoverLeft < 10) {
                            popoverLeft = 20;
                        }

                        // Aplica as coordenadas recalculadas e seguras
                        this.popoverStyle = {
                            top: `${popoverTop}px`,
                            left: `${popoverLeft}px`
                        };
                    }, 400); // Aguarda 400ms para o scroll suave terminar
                }
            });
        },
        openAiModal() {
            this.aiObjective = ''; // Limpa o campo ao abrir
            this.showAiModal = true;
        },

        closeAiModal() {
            if (!this.aiLoading) {
                this.showAiModal = false;
            }
        },

        async generateWithAi() {
            if (this.aiObjective.length < 5) {
                this.showAlert('Por favor, descreva melhor o seu objetivo.', 'error');
                return;
            }

            this.aiLoading = true;

            try {
                const response = await api.post('/capture-pages/ai-suggest', {
                    objective: this.aiObjective
                });

                if (response.data.success && response.data.data) {
                    const aiData = response.data.data;

                    // Preenche o formulário com a resposta da IA
                    this.form.title = aiData.title || this.form.title;
                    this.form.subtitle = aiData.subtitle || this.form.subtitle;
                    this.form.button_text = aiData.button_text || this.form.button_text;
                    this.form.gradient_start_color = aiData.gradient_start_color || this.form.gradient_start_color;
                    this.form.gradient_end_color = aiData.gradient_end_color || this.form.gradient_end_color;
                    this.form.button_color = aiData.button_color || this.form.button_color;

                    // Substitui os campos pelos sugeridos pela IA
                    if (aiData.fields && Array.isArray(aiData.fields)) {
                        this.form.fields = aiData.fields;
                    }

                    if (aiData.banner_url) {
                        this.previews.banner = aiData.banner_url;
                        // Guardamos a URL no form caso precisemos enviá-la para o backend no savePage
                        this.form.ai_banner_url = aiData.banner_url;
                    }

                    this.showAlert('Estratégia gerada com sucesso! Revise os dados no Live Preview.');
                    this.aiLoading = false;
                    this.showAiModal = false;
                }
            } catch (e) {
               if (e.response?.status === 403) {
                    this.showAlert("Permissão de acesso ao recurso não autorizada.", "error");
                }else if (e.response?.status === 422) {
                    const validationErrors = e.response.data?.data || e.response.data?.errors;
                    this.errors = validationErrors || {};
                    if (!validationErrors || Object.keys(validationErrors).length === 0) {
                        this.showAlert("Erro de validação. Verifique os campos preenchidos.", "error");
                        return;
                    }
                    let mensagensErro = "Os seguintes campos precisam de correção:\n\n";
                    for (const campo in validationErrors) {
                        mensagensErro += `- ${validationErrors[campo][0]}\n`;
                    }

                    this.showAlert(mensagensErro, "error");

                } else {
                    console.error("Erro desconhecido:", e);
                    this.showAlert("Erro ao realizar comunicação com IA.", "error");
                }
            } finally {
                this.aiLoading = false;
            }
        },
        resetForm() {
            // 1. Restaura os valores de texto e cores para o padrão
            this.form = {
                title: '',
                subtitle: '',
                gradient_start_color: '#f8fafc',
                gradient_end_color: '#e2e8f0',
                destination_url: '',
                thank_you_text: 'Seus dados foram enviados com sucesso!',
                fields: [],
                logo_file: null,
                banner_file: null,
                button_text: 'ENVIAR DADOS',
                button_color: '#561569',
                ai_banner_url: null,
                banner_size: 'standard',
                logo_size: 'standard'
            };

            // 2. Limpa as imagens do Live Preview
            this.previews = {
                logo: null,
                banner: null
            };

            // 3. Limpa o objetivo do modal da IA
            this.aiObjective = '';

            // 4. Força a recriação dos componentes Cropper para limpar as imagens
            this.cropperKey++;
        },

        handleCropped(blob, type) {
            if (type === 'logo') {
                this.form.logo_file = blob;
                if (this.previews.logo) URL.revokeObjectURL(this.previews.logo);
                this.previews.logo = URL.createObjectURL(blob);
            } else if (type === 'banner') {
                this.form.banner_file = blob;
                if (this.previews.banner) URL.revokeObjectURL(this.previews.banner);
                this.previews.banner = URL.createObjectURL(blob);
            }
        },
        async fetchPageData(id) {
            this.loading = true;
            try {
                const response = await api.get(`/capture-pages/${id}`);
                const pageData = response.data.data;

                // Preenche os campos básicos do form
                this.form.title = pageData.title || '';
                this.form.subtitle = pageData.subtitle || '';
                this.form.gradient_start_color = pageData.gradient_start_color || '#f8fafc';
                this.form.gradient_end_color = pageData.gradient_end_color || '#e2e8f0';
                this.form.destination_url = pageData.destination_url || '';
                this.form.thank_you_text = pageData.thank_you_text || 'Seus dados foram enviados com sucesso!';
                this.form.button_text = pageData.button_text || 'ENVIAR DADOS';
                this.form.button_color = pageData.button_color || '#561569';
                this.form.banner_size = pageData.banner_size || 'standard';
                this.form.logo_size = pageData.logo_size || 'standard'

                // Preenche os campos dinâmicos mapeando as opções se existirem
                // Preenche os campos dinâmicos mapeando as opções se existirem
                if (pageData.fields && Array.isArray(pageData.fields)) {
                    this.form.fields = pageData.fields.map(f => {
                        // Tratamento robusto para as opções vindas da API
                        let loadedOptions = '';

                        if (Array.isArray(f.options)) {
                            // Se já for um array real
                            loadedOptions = f.options.join(',');
                        } else if (typeof f.options === 'string') {
                            try {
                                // Tenta fazer o parse caso venha como JSON stringificado
                                const parsed = JSON.parse(f.options);
                                loadedOptions = Array.isArray(parsed) ? parsed.join(',') : f.options;
                            } catch (e) {
                                // Se falhar o parse, assume que é uma string normal separada por vírgulas
                                loadedOptions = f.options;
                            }
                        } else {
                            // Fallback
                            loadedOptions = f.options_text || '';
                        }

                        return {
                            id: f.id,
                            name: f.name || f.label.toLowerCase().replace(/[^a-z0-9]+/g, '_'),
                            label: f.label || '',
                            type: f.type || 'text',
                            is_required: !!f.is_required,
                            is_identifier: !!f.is_identifier,
                            options_text: loadedOptions
                        };
                    });
                }

                // Carrega URLs existentes para o Preview em tempo real
                if (pageData.logo_url) this.previews.logo = pageData.logo_url;
                if (pageData.banner_url) this.previews.banner = pageData.banner_url;

            } catch (error) {
                console.error(error);
                this.showAlert('Erro ao carregar dados da página para edição.', 'error');
            } finally {
                this.loading = false;
            }
        },
        setIdentifier(selectedIndex) {
            this.form.fields.forEach((f, idx) => {
                f.is_identifier = (idx === selectedIndex);
            });
        },
    }
}
</script>

<style scoped>
/* ESTILOS DE ALERTA (MANTIDOS) */
.toast {
    min-width: 300px;
    border-radius: 12px;
    background-color: white !important;
}

.bg-success-subtle {
    background-color: #ecfdf5 !important;
    color: #059669 !important;
    border-left: 5px solid #059669 !important;
}

.bg-error-subtle {
    background-color: #fef2f2 !important;
    color: #991b1b !important;
    border-left: 5px solid #ef4444 !important;
}

/* LAYOUT PMG MANTIDO */
.main-content {
    background-color: #f8fafc;
    min-height: 100vh;
    padding: 2rem;
    font-family: 'Inter', sans-serif;
}

.card {
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.02);
}

.btn-pmg-primary {
    background: #561569;
    color: #fff;
    border: none;
    border-radius: 10px;
    padding: 10px 20px;
    font-weight: 500;
    transition: 0.3s;
}

.btn-pmg-primary:hover {
    background: #451054;
}

.btn-pmg-primary:disabled {
    opacity: 0.5;
}

.btn-pmg-light {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    color: #64748b;
    padding: 10px 20px;
}

.form-control-pmg {
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    padding: 12px;
}

.form-control-pmg:focus {
    border-color: #561569;
    box-shadow: 0 0 0 4px rgba(86, 21, 105, 0.1);
}

.form-control-color {
    height: 45px;
}

/* ESTILOS DO LIVE PREVIEW (NOVOS) */
.preview-container {
    border: 8px solid white;
    /* Moldura estilo celular/card */
    transition: background 0.3s ease;
}

.preview-banner {
    height: 150px;
    width: 100%;
}

.preview-logo-wrapper {
    position: relative;
    z-index: 2;
}

.preview-logo {
    width: 80px;
    height: 80px;
}

.preview-logo img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* Transições de alerta */
.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.4s ease;
}

.slide-fade-enter-from {
    transform: translateX(100px);
    opacity: 0;
}

.slide-fade-leave-to {
    opacity: 0;
    transform: scale(0.9);
}

.breadcrumb {
    flex-wrap: nowrap;
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none;
}

.breadcrumb::-webkit-scrollbar {
    display: none;
}

.breadcrumb-item .nav-link {
    display: inline;
    padding: 0;
}

/* Fundo escuro que cobre tudo */
.tour-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 1050;
    backdrop-filter: blur(2px);
}

/* O balão de texto flutuante */
.tour-popover {
    position: fixed;
    width: 300px;
    background: #ffffff;
    border-radius: 12px;
    padding: 1.5rem;
    z-index: 1060;
    border: 1px solid #e2e8f0;
}

/* 
 * A classe que será injetada dinamicamente no seu HTML.
 * Ela garante que o elemento da sua página fique ACIMA do fundo escuro.
 */
.tour-highlight {
    position: relative;
    z-index: 1055 !important;
    background-color: #ffffff;
    border-radius: 12px;
    box-shadow: 0 0 0 4px rgba(255, 255, 255, 0.2);
    pointer-events: none;
    /* Evita que o usuário clique e edite os campos durante o tour */
    transition: all 0.3s ease;
}

/* Animações suaves do Vue */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.popover-anim-enter-active,
.popover-anim-leave-active {
    transition: all 0.3s ease;
}

.popover-anim-enter-from,
.popover-anim-leave-to {
    opacity: 0;
    transform: translateY(-10px);
}

.tour-popover {
    position: fixed;
    width: 380px;
    /* Aumentado para acomodar os botões e a badge */
    max-width: 90vw;
    /* Proteção para telas menores (mobile) */
    background: #ffffff;
    border-radius: 12px;
    padding: 1.5rem;
    z-index: 1060;
    border: 1px solid #e2e8f0;
}

.ai-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(15, 23, 42, 0.7);
    z-index: 1070;
    /* Acima de tudo */
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(4px);
}

.ai-modal-content {
    width: 100%;
    max-width: 500px;
    margin: 0 20px;
    transform: translateY(0);
    transition: all 0.3s ease;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>